export const GradesCards = [
  {
    name: 'не знал',
    value: 1,
  },
  {
    name: 'крутилось на языке',
    value: 2,
  },
  {
    name: 'еле вспомнил',
    value: 3,
  },
  {
    name: 'знал',
    value: 4,
  },
  {
    name: 'среди ночи разбудите - расскажу',
    value: 5,
  },
];
